import Immutable from "immutable";
import store from "store2";
import { push } from "react-router-redux";

const LOAD = "auth/LOAD";
const LOAD_SUCCESS = "auth/LOAD_SUCCESS";
const LOAD_FAIL = "auth/LOAD_FAIL";

const LOGIN = "auth/LOGIN";
const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
const LOGIN_FAIL = "auth/LOGIN_FAIL";

const SIGNUP = "auth/SIGNUP";
const SIGNUP_SUCCESS = "auth/SIGNUP_SUCCESS";
const SIGNUP_FAIL = "auth/SIGNUP_FAIL";
const SET_ACTIVE_PROFILE = "auth/SET_ACTIVE_PROFILE";
const CLOSE_ERROR_MESSAGE = "auth/CLOSE_ERROR_MESSAGE";

export const LOGOUT = "auth/LOGOUT";

const FLUSH = "auth/FLUSH";
const LOAD_MYCDP_URI = "auth/MYCDP_URI";
const LOAD_SCHEDULE_DOCTORS = "auth/LOAD_SCHEDULE_DOCTORS";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  isLogin: false,
  loginErr: null,
  user: null,
  loading: false,
  signupError: null,
  activeProfile: null,
  mycdp_uri: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_SUCCESS:
      return state.set("isLoad", false).set("user", action.user);

    case LOAD_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("user", {});

    case LOGIN:
      return state.set("isLogin", true).set("loginErr", null);

    case LOGIN_SUCCESS:
      return state.set("isLogin", false).set("user", action.user);

    case LOGIN_FAIL:
      return state
        .set("isLogin", false)
        .set("loginErr", action.error)
        .set("user", null);

    case SIGNUP:
      return state.set("loading", true).set("signupError", null);

    case SIGNUP_SUCCESS:
      return state
        .set("loading", false)
        .set("signupError", null)
        .set("user", action.user);

    case SIGNUP_FAIL:
      return state
        .set("loading", false)
        .set("signupError", action.error)
        .set("user", null);

    case LOGOUT:
    case FLUSH: {
      return initialState;
    }
    case LOAD_SCHEDULE_DOCTORS: {
      // Merge the separately-fetched doctors list into the existing user
      // without disturbing the rest of the user object.
      const currentUser = state.get("user");
      if (!currentUser || !currentUser.id) {
        return state;
      }
      return state.set(
        "user",
        Object.assign({}, currentUser, { scheduleDoctors: action.doctors }),
      );
    }
    case SET_ACTIVE_PROFILE:
      return state.set("activeProfile", action.result);
    case LOAD_MYCDP_URI:
      return state.set("mycdp_uri", action.mycdp_uri);
    default:
      return state;
  }
}

export const hideErrorModal = () => async (dispatch) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
};

export function redirectUser(user) {
  if (user && user.srole && user.Doctor && user.Doctor.defaultPage) {
    return user.Doctor.defaultPage;
  } else if (user && user.srole) {
    return "schedule";
  } else {
    return "not-authorize";
  }
}

export function setActiveProfile(profile) {
  return (dispatch) =>
    new Promise(function () {
      dispatch({ type: SET_ACTIVE_PROFILE, result: profile });
    });
}

export const changeDoctorAbbr = (abbr) => async (dispatch, getState) => {
  const user = getState().get("auth").get("user");
  if (abbr === "undo" && user) {
    user.UdaDrList.abbr = user.UdaDrList.defaultAbbr;
    user.UdaDrList.prodAdjWo = user.UdaDrList.defaultProdAdjWo;
    user.UdaDrList.userId = user.UdaDrList.defaultUserId;
    user.UdaDrList.firstStart = user.UdaDrList.defaultFirstStart;
    dispatch({ type: LOAD_SUCCESS, user: user });
  } else if (abbr && user) {
    user.UdaDrList.abbr = abbr;
    user.UdaDrList.prodAdjWo = 100;
    if (user.drList[2] && user.drList[2][abbr]) {
      user.UdaDrList.userId = user.drList[2][abbr].userId;
      user.UdaDrList.firstStart = user.drList[2][abbr].firstStart;
      if (user.drList[2][abbr].prodAdjWo)
        user.UdaDrList.prodAdjWo = user.drList[2][abbr].prodAdjWo;
    } else if (user.drList[3] && user.drList[3][abbr]) {
      user.UdaDrList.userId = user.drList[3][abbr].userId;
      user.UdaDrList.firstStart = user.drList[3][abbr].firstStart;
      if (user.drList[3][abbr].prodAdjWo)
        user.UdaDrList.prodAdjWo = user.drList[3][abbr].prodAdjWo;
    }
    dispatch({ type: LOAD_SUCCESS, user: user });
  }
  return true;
};

export const load = (forced) => async (dispatch, getState, api) => {
  // dont call api if user data is in state
  const user = getState().get("auth").get("user");
  if (user && !forced) {
    return;
  }
  dispatch({ type: LOAD });
  try {
    const res = await api.get("/sessions");
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    if (res.accessToken) {
      store("authToken", res.accessToken);
    }
    dispatch({ type: LOAD_SUCCESS, user: res });
    // Fetch the schedule-doctors list separately so it never blocks the
    // session response / sign-in. It merges into the user once it arrives.
    dispatch(loadScheduleDoctors());
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, error: error });
  }
};

export const loadScheduleDoctors = () => async (dispatch, getState, api) => {
  try {
    const doctors = await api.get("/scheduler/scheduleDoctors");
    dispatch({ type: LOAD_SCHEDULE_DOCTORS, doctors });
  } catch (e) {
    // Non-fatal: components guard for an empty scheduleDoctors, so a failure
    // here just means no doctor names until the next successful load.
    console.error("loadScheduleDoctors failed (non-fatal):", e);
  }
};

// profileObj is either the form-login payload ({ username, password, loginWithForm })
// or { credential } holding the Google Sign-In ID token, which the API verifies.
export const login = (profileObj) => async (dispatch, getState, api) => {
  dispatch({ type: LOGIN });
  try {
    let postObj;
    let url = "/sessions?jwt=1";
    if (profileObj.loginWithForm) {
      postObj = profileObj;
      url = "/login/sessions?jwt=1";
    } else {
      postObj = { credential: profileObj.credential };
    }
    const res = await api.post(url, { data: postObj });

    dispatch({ type: LOGIN_SUCCESS, user: res });
    store("authToken", res.accessToken);
    dispatch(setActiveProfile());
    dispatch(load(true));
    // Usage tracking only — must never block or fail the login flow.
    try {
      await api.post("/savePartners", {
        data: { userId: res.user.id, partnerName: "Schedule" },
      });
    } catch (e) {
      console.error("savePartners failed (non-fatal):", e);
    }
    const homeUrl = redirectUser(res.user);
    dispatch(push(`/${homeUrl}`));
    return res;
  } catch (err) {
    dispatch({ type: LOGIN_FAIL, error: err.message });
  }
};

export const logout = () => (dispatch) => {
  store.remove("authToken");
  store.remove("refreshToken");
  store.remove("loginWithForm");
  dispatch({ type: LOGOUT });
  dispatch({ type: "FLUSH" });
  dispatch(push("/"));
};

export const cdpLogin = (accessToken) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/sessions/cdpLogin/${accessToken}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    if (res.accessToken) {
      store("authToken", res.accessToken);
    }
    dispatch({ type: LOAD_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, error: error });
  }
};
export const getDentalPartners = () => async (dispatch, getState, api) => {
  try {
    const user = getState().get("auth").get("user");
    const resp = await api.get(`/getPartnersList/${user.id}`, {});
    dispatch({ type: LOAD_MYCDP_URI, mycdp_uri: resp.partners_uri });
    return resp;
  } catch (err) {
    return err;
  }
};
